/* eslint-disable no-undef */
(function ($) {
  const modalLinks = document.querySelectorAll('.link--modal');

  if (!modalLinks) {
    return;
  }

  // Basic fetch request data
  const modalRequest = {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    },
    body: 'action=get_modal_content',
  };

  /**
   * Open modal function
   */
  const openModal = e => {
    e.preventDefault();
    const modalName = e.currentTarget.dataset.modal;
    if (!modalName) {
      return;
    }

    // Append modal_id to request
    modalRequest.body += `&modal_id=${modalName}`;
    fetch(ajaxurl, modalRequest).then(res => {
      if (res.status !== 200) {
        return;
      }

      res.json().then(json => {
        if (json.show === false) {
          return;
        }

        // Get the modal and populate content
        const infoModal = document.querySelector('.cc-modal--info');
        const modalBody = infoModal.querySelector('.modal-body');
        modalBody.innerHTML = json.content;

        // Open Bootstrap Modal
        $(infoModal).modal();
      });
    });
  };

  modalLinks.forEach(modalLink => {
    modalLink.addEventListener('click', openModal);
  });
})(jQuery); // jQuery for Bootstrap modal
